export const RAY_WHITE_CONCIERGE_SEND_LABEL =
  'Send Ray White Concierge referral'
export const RAY_WHITE_CONCIERGE_SEND_IF_NOT_SENT_LABEL = `${RAY_WHITE_CONCIERGE_SEND_LABEL} if not already sent (if opted in)`
